import { combineReducers } from 'redux';

import base from './base';
import chat from './chat';
import stock from './stock';

/* 리듀서 병합 */
export default combineReducers({
    base,
    chat,
    stock,
});